// export function getMonthlyDateRange(): { fromDate: string; toDate: string } {
//   const now = new Date();

//   // Convert to IST
//   const istNow = new Date(
//     now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })
//   );

//   const istStart = new Date(
//     istNow.getFullYear(),
//     istNow.getMonth(),
//     1,
//     0,
//     0,
//     0,
//     0
//   );

//   // End of month (last day, 23:59:59)
//   const istEnd = new Date(
//     istNow.getFullYear(),
//     istNow.getMonth() + 1,
//     0,
//     23,
//     59,
//     59,
//     999
//   );

//   return {
//     fromDate: istStart.toISOString(),
//     toDate: istEnd.toISOString(),
//   };
// }

export function getMonthlyDateRange(monthType: 'current' | 'next' = 'current'): {
  fromDate: string;
  toDate: string;
} {
  const now = new Date();

  const istNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

  let year = istNow.getFullYear();
  let month = istNow.getMonth();

  if (monthType === 'next') {
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
  }
  console.log(month);

  const startOfMonth = new Date(year, month, 1, 0, 0, 0, 0);

  const endOfMonth = new Date(year, month + 1, 0, 23, 59, 59, 999);

  return {
    fromDate: startOfMonth.toISOString(),
    toDate: endOfMonth.toISOString(),
  };
}
